;(function(){
    'use strict';

    angular
        .module("EMR.Home")
        .service('EmrPatientInfoMaskingService', EmrPatientInfoMaskingService);

        EmrPatientInfoMaskingService.$inject=['EmrMaskingPropertiesList'];
    function EmrPatientInfoMaskingService(EmrMaskingPropertiesList){
        return{
            checkPropertyisExistorNot:checkPropertyisExistorNot,
        }
        
        function AleterPAtientInfowithMasking(data){
            data.forEach(function(eachData){
                EmrMaskingPropertiesList.forEach(function(property){
                    if (eachData.hasOwnProperty(property) && eachData[property]){
                        if (checkisNotPatientTestInfo(eachData[property]))
                            eachData[property] = emrConfidentialdataMaskingString;
                    }
                });
            });
            return data;
        }
        
        function checkisNotPatientTestInfo(patientDetails){
            patientDetails =patientDetails.toLowerCase();
            if(patientDetails.includes('test')||patientDetails.includes('client') ||patientDetails.includes('support')||patientDetails.includes('patient'))return false;
            return true;
        }

        function checkPropertyisExistorNot(data){
            if(data && data.length){
               data = AleterPAtientInfowithMasking(data);
            }
            else if(data){
                var objectKeys = Object.keys(data);
                objectKeys.forEach(function(eachKey){
                    if(Array.isArray(data[eachKey])){
                        data[eachKey] = AleterPAtientInfowithMasking(data[eachKey]);
                    }
                    else if(typeof data[eachKey] == 'object'){
                        data[eachKey] = checkPropertyisExistorNot(data[eachKey]);
                    }
                    else{
                        if(new Set(EmrMaskingPropertiesList).has(eachKey)){
                            data[eachKey] = emrConfidentialdataMaskingString;
                        }
                    }
                })

            }
           
            return data;
        }
        
    }

}());